import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withKeys as _withKeys, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-60a83a86")

_pushScopeId("data-v-60a83a86")
const _hoisted_1 = { class: "dt-open-api-select-box" }
const _hoisted_2 = { class: "dt-open-api-page-search" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("全选")
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { style: {"text-align":"right","margin-top":"10px"} }
const _hoisted_7 = {
  key: 0,
  class: "dt-open-api-seleted-area"
}
const _hoisted_8 = { class: "dialog-footer" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("授权")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("关闭")
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _component_el_dialog = _resolveComponent("el-dialog")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_el_dialog, {
      title: "API申请",
      modelValue: _ctx.dialogVisible,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => (_ctx.dialogVisible = $event)),
      width: "700px",
      "close-on-click-modal": _ctx.clickModalClose,
      "before-close": _ctx.handleClose
    }, {
      footer: _withId(() => [
        _createVNode("span", _hoisted_8, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _ctx.authAPI
          }, {
            default: _withId(() => [
              _hoisted_9
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, { onClick: _ctx.handleClose }, {
            default: _withId(() => [
              _hoisted_10
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: _withId(() => [
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_el_select, {
            modelValue: _ctx.groupId,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (_ctx.groupId = $event)),
            onChange: _ctx.getAPIs,
            placeholder: "请选择分组",
            "no-data-text": "暂无数据"
          }, {
            default: _withId(() => [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.groups, (item) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: item.id,
                  label: item.title,
                  value: item.id
                }, null, 8, ["label", "value"]))
              }), 128 /* KEYED_FRAGMENT */)),
              _createVNode(_component_el_option, {
                label: "全部分组",
                value: ""
              })
            ]),
            _: 1
          }, 8, ["modelValue", "onChange"]),
          _createVNode(_component_el_input, {
            placeholder: "请输入关键词搜索",
            style: {"width":"240px","margin-right":"20px"},
            modelValue: _ctx.keyWord,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (_ctx.keyWord = $event)),
            onKeydown: _withKeys(_ctx.handleSearch, ["enter"])
          }, {
            append: _withId(() => [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _ctx.handleSearch
              }, {
                default: _withId(() => [
                  _hoisted_3
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          }, 8, ["modelValue", "onKeydown"])
        ]),
        _createVNode(_component_el_checkbox, {
          modelValue: _ctx.selectAllStatu,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (_ctx.selectAllStatu = $event)),
          onChange: _cache[4] || (_cache[4] = $event => (_ctx.handleSelectAll(_ctx.selectAllStatu)))
        }, {
          default: _withId(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_el_table, {
          data: _ctx.apis.rows,
          "empty-text": "暂无数据",
          ref: "tableRef",
          onSelectionChange: _ctx.selectionChange,
          style: {"width":"100%"}
        }, {
          default: _withId(() => [
            _createVNode(_component_el_table_column, {
              prop: "title",
              label: " API名称"
            }),
            _createVNode(_component_el_table_column, {
              prop: "description",
              label: "说明"
            }),
            _createVNode(_component_el_table_column, {
              fixed: "right",
              label: "操作",
              width: "100"
            }, {
              default: _withId((scope) => [
                (scope.row.applied == 1)
                  ? (_openBlock(), _createBlock("span", _hoisted_5, "已申请"))
                  : (_openBlock(), _createBlock(_component_el_button, {
                      key: 1,
                      onClick: $event => (_ctx.tableRowClick(scope.row)),
                      type: "text",
                      class: "click-element"
                    }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(JSON.stringify(_ctx.selAPIList).indexOf(scope.row.id) > -1 ? '取消选择':'选择'), 1 /* TEXT */)
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data", "onSelectionChange"]),
        _createVNode("div", _hoisted_6, [
          _createVNode(_component_el_pagination, {
            background: "",
            layout: "prev, pager, next",
            currentPage: _ctx.page,
            "onUpdate:currentPage": _cache[5] || (_cache[5] = $event => (_ctx.page = $event)),
            total: _ctx.apis.total_rows,
            "page-size": _ctx.apis.limit,
            onCurrentChange: _ctx.getAPIs
          }, null, 8, ["currentPage", "total", "page-size", "onCurrentChange"])
        ]),
        (_ctx.selAPIList.length > 0)
          ? (_openBlock(), _createBlock("div", _hoisted_7, [
              _createVNode("ul", null, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.selAPIList, (item, index) => {
                  return (_openBlock(), _createBlock("li", {
                    key: item.id
                  }, [
                    _createVNode("div", {
                      class: "dt-open-api-seleted-item",
                      title: item.title
                    }, [
                      _createVNode("p", null, _toDisplayString(item.title), 1),
                      _createVNode("div", {
                        class: "dt-open-api-seleted-remove click-element",
                        onClick: $event => (_ctx.removeItem(index))
                      }, null, 8, ["onClick"])
                    ], 8, ["title"])
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "close-on-click-modal", "before-close"])
  ]))
})